import React, { useEffect, useState } from "react";
import { useLang } from "../context/LangContext";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";

const CATEGORIES = ["all", "collares", "aretes", "pulseras", "anillos"];

export default function Shop() {
  const { t } = useLang();
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = active === "all" ? {} : { category: active };
    api.get("/products", { params }).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [active]);

  return (
    <div data-testid="shop-page" className="pt-32 pb-16 max-w-7xl mx-auto px-6 min-h-screen">
      <div className="mb-12">
        <p className="overline text-brand-primary mb-3">{t("nav_shop")}</p>
        <h1 className="font-heading text-5xl md:text-6xl font-light tracking-tighter text-ink">{t("shop_title")}</h1>
        <p className="text-ink-soft mt-3 max-w-md">{t("shop_sub")}</p>
      </div>

      <div className="flex flex-wrap gap-3 mb-14">
        {CATEGORIES.map((cat) => (
          <button
            key={cat}
            data-testid={`filter-${cat}`}
            onClick={() => setActive(cat)}
            className={`px-5 py-2 text-sm uppercase tracking-wide border transition-colors ${
              active === cat
                ? "bg-ink text-canvas border-ink"
                : "border-brand-secondary text-ink-soft hover:border-ink"
            }`}
          >
            {cat === "all" ? t("filter_all") : t(`cat_${cat}`)}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="animate-pulse">
              <div className="aspect-[4/5] bg-canvas-deep mb-4" />
              <div className="h-4 bg-canvas-deep w-2/3" />
            </div>
          ))}
        </div>
      ) : products.length === 0 ? (
        <p className="text-ink-soft py-20 text-center">—</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
